module.exports = __webpack_public_path__ + "img/pick2_blue.52f6d911.png";